module.exports = {
  btnText: {
    name1: 'confirm',
    name2: 'Back to home page',
    name3: 'cancel'
  },
  text: {
    name1: 'I have read it carefully',
    name2: 'User agreement',
    name3: 'Privacy policy',
    name4: 'Warm Notice',
    name5: 'Agreement read and agreed',
    name6: 'Disagree and exit the system',
    name7: 'Welcome to use this system！',
    name8: 'Before you use this software, please read carefully and agree',
    name9: 'User agreement',
    name10: 'Privacy policy'
  },
  addressV2: {
    name1: 'cancel',
    name2: 'Please Choose the Adress',
    name3: 'confirm',
    name4: 'Please Choose'
  },
  empty: {
    name1: 'Sorry. No Data',
    name2: 'Its over',
    name3: 'No more'
  },
  date: {
    name1: '',
    name2: '',
    name3: '',
    name4: '',
    name5: ''
  },
  address: {
    name1: 'Fujian',
    name2: 'Xiamen',
    name3: 'Siming',
  },
  error: {
    name1: 'Do not submit repeatedly',
    name2: 'Please select a full address',
    name3: 'Please check the“I guarantee that all above contents are real, I would like to undertake all legel resonsibility.',
  },
  dialog: {
    name1: 'Warm Notice',
    name2: 'Please recheck above information and confirm.',
    name3: 'After review rejection, it cannot be undone, please proceed with caution!',
    name4: 'agree'
  },
  success: {
    name1: 'Submitted successfully',
    name2: 'Through success',
    name3: 'Refuse to succeed'
  },
  identityChoice: {
    name1: 'important notice',
    name2: 'Please choose your identity.'
  },
  home: {
    name1: 'important notice'
  },
  personnellist: {
    name1: 'Name List',
    name2: 'Male',
    name3: 'Female',
    name4: '',
    name5: '',
    name6: 'Mobile Phone No.',
    name7: 'Date of Filling the Form',
    name8: 'New Registration Person',
    name9: 'Health Records',
  },
  healthInfoIdByCardNo: {
    name1: 'Full Name',
    name2: 'Type of ID',
    name3: 'Resident ID Card No',
    name4: 'Guardian ID Card No',
    name5: 'Passport No.',
    name6: 'ID No.',
    name7: 'ID No.',
    name8: 'Next Step',
    name9: 'Please choose the Type of ID',
    name10: 'Please fill in the name',
    name11: 'Please fill in Resident ID Card No',
    name12: 'Resident ID Card',
    name13: 'Guardian ID Card',
    name14: 'Passport',
    name15: 'Mainland Travel Permit for Hong Kong and Macao Residents',
    name16: 'Mainland travel permit for Taiwan residents',
    name17: 'Please fill in the name',
    name18: 'Please choose the Type of ID',
    name19: 'Please fill in ',
    name20: 'Please fill in the passport No.',
    name21: 'Please fill in Mainland Travel Permit for Hong Kong and Macao Residents',
    name22: 'Please fill in Mainland travel permit for Taiwan residents'
  },
  healthrecord: {
    name1: 'Health Records',
    name2: 'Symptom',
    name3: 'Cough',
    name4: 'fatigue',
    name5: 'anhelation',
    name6: 'chest tightness',
    name7: 'diarrhoea',
    name8: 'without',
    name9: 'Other',
    name10: 'temperature',
    name11: 'Hospitalized patients',
    name12: 'Admitted hospital',
    name13: 'Admission time',
    name14: 'Discharge time',
    name15: '责任医生',
    name16: '联系电话',
    name17: '随访结果',
    name18: '正常完成',
    name19: '未见到管理对象',
    name20: 'Other',
    name21: '随访情况',
    name22: 'My Records',
    name23: 'Add health record',
    name24: 'There are no health records at present'
  },
  temperature: {
    name1: 'Add health record',
    name2: 'Registration time',
    name3: 'Please fill in',
    name4: 'temperature',
    name5: 'Please choose the temperature',
    name6: 'Hospitalized patients',
    name7: 'Yes',
    name8: 'No',
    name9: 'Admitted hospital',
    name10: 'Please fill in the admitted hospital',
    name11: 'Admission time',
    name12: 'Please choose the date',
    name13: 'Discharge time',
    name14: 'Please choose the date',
    name15: 'symptom【Multiple selection】',
    name16: 'Cough',
    name17: 'anhelation',
    name18: 'Other',
    name19: 'Please describe your symptoms',
    name20: 'No above symptoms',
    name21: '责任医生',
    name22: '请输入责任医生',
    name23: '联系电话',
    name24: '请输入联系电话',
    name25: '随访结果',
    name26: '正常完成',
    name27: '未见到管理对象',
    name28: 'Other',
    name29: 'preserve',
    name30: 'Please choose the registration time',
    name31: 'Please choose the temperature',
    name32: 'Please fill in the admitted hospital',
    name33: 'Please choose the Admission time',
    name34: 'Please choose the Discharge time',
    name35: 'Please tick the symptom',
    name36: '请输入责任医生',
    name37: '请输入责任医生电话',
    name38: '请输入医生正确的手机号码',
    name39: '请选择随访结果',
  },
  registration: {
    name1: 'Report and Registration',
    name2: 'Relationship',
    name3: 'Please choose the he relationship with you',
    name4: 'Full Name',
    name5: 'Please fill in the name',
    name6: 'Gender',
    name7: 'Please choose the gender',
    name8: 'Type of ID',
    name9: 'Resident ID Card No',
    name10: 'Guardian ID Card No',
    name11: 'Passport No.',
    name12: 'ID No.',
    name13: 'ID No.',
    name14: 'Please fill in',
    name15: 'Date of Birth',
    name16: 'Please choose the date',
    name17: 'age',
    name18: '',
    name19: 'Months',
    name20: 'Please fill in',
    name21: 'month',
    name22: 'Mobile Phone No',
    name23: 'Please fill in the mobile phone No.',
    name24: 'Company Name',
    name25: 'Please fill in the company name',
    name26: 'emergency contact person',
    name27: 'Please fill in the emergency contact person',
    name28: 'emergency contact No.',
    name29: 'Please fill in the emergency contact No.',
    name30: 'Health Status when fill in the form',
    name31: 'Please choose the Health Status when fill in the form',
    name32: 'Current Adress',
    name33: 'Please Choose',
    name34: 'Current Adress Details',
    name35: 'Please choose the current adress details',
    name36: '建档机构',
    name37: '请选择建档机构',
    name38: 'Residents Committee',
    name39: 'Please choose the residents committee',
    name40: '人员',
    name41: '请选择人员类型',
    name42: '入闽时间',
    name43: '入闽目的',
    name44: '请选择入闽目的',
    name45: '来闽曾停留县区',
    name46: '请输入来闽曾停留县区',
    name47: '来闽交通方式',
    name48: '请选择来闽交通方式',
    name49: '具体班次',
    name50: '请输入你所乘坐的班次编号',
    name51: '接触时间',
    name52: 'Please choose the date',
    name53: '接触后曾停留县',
    name54: '请输入接触后曾停留县',
    name55: 'The travelling of my family and me ',
    name56: 'Been to deseased-affected areas in the last 14 days',
    name57: 'Been contact with person from deseased-affected areas in the last 14 days',
    name58: 'Been contact with confirmed or suspected patients',
    name59: 'Lived in or travelled to Hubei in the last 14 days',
    name60: 'Been to other province (Except Hubei)',
    name61: 'Been Abroad',
    name62: 'No above experience',
    name63: 'Departure Place',
    name64: 'Please Choose',
    name65: 'Departure Date',
    name66: 'Please choose the date',
    name67: 'Date to Xiamen',
    name68: 'Please choose the date',
    name69: 'Purpose of coming to Xiamen',
    name70: 'Please choose the purpose of coming to Xiamen',
    name71: 'Type of Transportation to Xiamen',
    name72: 'Please choose the type of transportation to Xiamen',
    name73: 'shift information',
    name74: 'Flight No.',
    name75: 'Train No.',
    name76: 'Bus No.',
    name77: 'License Plate No.',
    name78: 'Taxi License No.',
    name79: 'By Ship',
    name80: 'Please fill in',
    name81: 'Remark',
    name82: 'Additional Necessary Notes',
    name83: '基础疾病情况',
    name84: '无',
    name85: '高血压',
    name86: '糖尿病 ',
    name87: '脑卒中',
    name88: '冠心病',
    name89: '哮喘',
    name90: 'Other',
    name91: '过敏史',
    name92: '请入过敏史',
    name93: 'Please choose the he relationship with you',
    name94: 'Please choose the gender',
    name95: '选择证件类型',
    name96: 'Please choose the Health',
    name97: '选择人员类型',
    name98: '选择是否湖北籍',
    name99: 'Please choose the Purpose',
    name100: '选择建档机构',
    name101: 'Please choose the type of transportation',
    name102: 'I guarantee that all above contents are real',
    name103: ' I would like to undertake all legel resonsibility。',
    name104: 'preserve',
    name105: 'preserve',
    name106: '拒绝',
    name107: '通过',
    name108: 'I',
    name109: 'Father',
    name110: 'Mother',
    name111: 'Spouse',
    name112: 'Children',
    name113: 'yes',
    name114: 'no',
    name115: 'Male',
    name116: 'Female',
    name117: 'Resident ID Card',
    name118: 'Guardian ID Card',
    name119: 'Passport',
    name120: 'Mainland Travel Permit for Hong Kong and Macao Residents',
    name121: 'Mainland travel permit for Taiwan residents',
    name122: 'Be hospitalized',
    name123: 'Quarantine',
    name124: 'Symptoms of discomfort',
    name125: 'Asymptomatic',
    name126: 'By Airplane',
    name127: 'By Train',
    name128: 'By Bus',
    name129: 'By Car',
    name130: 'By Taxi',
    name131: 'By Ship',
    name132: '来自或密切接触湖北人员',
    name133: '来自或密切接触境外人员',
    name134: 'Go Home',
    name135: 'Visit Relatives',
    name136: 'Travel',
    name137: 'On Business',
    name138: 'For Work',
    name139: 'For Education',
    name140: 'Please choose the he relationship with you',
    name141: 'Please fill in the name',
    name142: '请输入性别',
    name143: '请输入年龄',
    name144: 'Please enter ID number',
    name145: 'Please fill in the passport No.',
    name146: 'Please fill in Mainland Travel Permit for Hong Kong and Macao Residents',
    name147: 'Please fill in Mainland travel permit for Taiwan residents',
    name148: 'Please fill in the mobile phone No.',
    name149: 'Please fill in the emergency contact person',
    name150: 'Please fill in the emergency contact No.',
    name151: 'Please choose the Health Status when fill in the form',
    name152: 'Please choose the Current Adress',
    name153: 'Please fill in the current adress details',
    name154: '请选择建档机构',
    name155: 'Please choose the residents committee',
    name156: '请选择人员类型',
    name157: '请选择入闽时间',
    name158: '请选择入闽目的',
    name159: 'Please choose the type of transportation to Xiamen',
    name160: '请输入来闽曾停留县区',
    name161: '请输入你所乘坐的班次编号',
    name162: '请选择接触时间',
    name163: 'Please choose the Departure Place',
    name164: 'Please choose the Departure Date',
    name165: 'Please choose the Date to Xiamen',
    name166: 'Please choose the purpose of coming to Xiamen',
    name167: 'Please choose the type of transportation to Xiamen',
    name168: '请勾选个人及家属返厦前行程经历',
    name169: '请勾选基础疾病情况',
    name170: 'Please fill in correct mobile number',
    name171: 'Please fill in correct emergency contact number',
    name172: 'Please fill in Valid ID number',
    name173: 'Please fill in Valid passport',
    name174: 'Emergency contact number cannot be the same as my mobile number！'
  }
}
